import sitelogo from '@/assets/images/sitelogo.svg';
import bannerBg from '@/assets/images/banner-bg.png';
import logoAndName from '@/assets/images/logo_and_name.png';

import moneybagWithCalculator from '@/assets/images/moneybag_with_calculator.png';
import shoppingCart from '@/assets/images/shopping_cart.png';
import standInstallDismantle from '@/assets/images/stand_install_dismantle.png';
import standPurchase from '@/assets/images/stand_purchase.png';
import standRental from '@/assets/images/stand_rental.png';
import doorToDoor from '@/assets/images/door_to_door.png';
import viaWarehouse from '@/assets/images/via_warehouse.png';
import siteBanner from '@/assets/images/site-banner.png';
import siteBannerVideo from '@/assets/images/site-banner-vid.mp4';
import truckWithLogo from '@/assets/images/truck-png.png';
import userProfile from '@/assets/images/user-profile.png';

export const SITE_LOGO_IMG = sitelogo;
export const BANNER_BG_IMG = bannerBg;
export const LOGO_AND_NAME_IMG = logoAndName;

export const MONEYBAG_WITH_CALCULATOR_IMG = moneybagWithCalculator;
export const SHOPPING_CART_IMG = shoppingCart;
export const STAND_INSTALL_DISMANTLE_IMG = standInstallDismantle;
export const STAND_PURCHASE_IMG = standPurchase;
export const STAND_RENTAL_IMG = standRental;
export const DOOR_TO_DOOR_IMG = doorToDoor;
export const VIA_WAREHOUSE_IMG = viaWarehouse;
export const SITE_BANNER_IMG = siteBanner;
export const SITE_BANNER_VIDEO = siteBannerVideo;
export const TRUCK_WITH_LOGO_IMG = truckWithLogo;
export const USER_PROFILE_IMG = userProfile;






